import { openCookieSettings } from "@/lib/cookieConsent";
import { cn } from "@/lib/utils";

interface CookieSettingsLinkProps {
  className?: string;
  label?: string;
}

/** Lien discret rouvrant le panneau de préférences cookies. */
export const CookieSettingsLink = ({
  className,
  label = "Cookies",
}: CookieSettingsLinkProps) => (
  <button
    type="button"
    onClick={openCookieSettings}
    className={cn(
      "text-xs text-muted-foreground underline underline-offset-2 hover:text-foreground",
      className,
    )}
  >
    {label}
  </button>
);

export default CookieSettingsLink;
